// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b35f5d3","98":"5cb0b4d3","251":"4aea230a","305":"a5f3cbb7","368":"2580949c","462":"ee2146de","490":"db0d2584","596":"87b8879f","763":"0de4382c","797":"cb9b53db","922":"3a2b0084","971":"39761da9","974":"fed664ab"}[chunkId] + ".chunk.js";
};